import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Carousel, CarouselItem, Message, Popover, Button, MessageBox, Dialog, Upload, Input, Tabs, TabPane, Pagination, Empty, Form, FormItem } from 'element-ui'
import './assets/theme/index.css'
import storage from '@/utils/storage'// 引入

import VueClipBoard from 'vue-clipboard2'

import Directive from './directives' // 自定义指令

if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  window.location.href = 'https://edu-h5.huashuyunai.com/#/'
}

Vue.use(Directive)

Vue.use(VueClipBoard)

Vue.prototype.$storage = storage// 加入vue的原型对象

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Popover)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Pagination)
Vue.use(Empty)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Upload)


Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
